export interface IApplicationState {

    startWinShower: boolean;
    showWinShower: boolean;
    winShowerAmount: number;

}

const initialState: IApplicationState = {
    startWinShower: false,
    showWinShower: false,
    winShowerAmount:0,


};

export enum actionTypes {

    START_WIN_SHOWER = '@@winShower/START_WIN_SHOWER',
    SHOW_WIN_SHOWER = '@@winShower/SHOW_WIN_SHOWER',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {startWinShower, showWinShower,winShowerAmount} = action;

    switch (action.type) {
        case actionTypes.START_WIN_SHOWER:
            return {
                ...state, startWinShower: startWinShower,winShowerAmount,
            };
        case actionTypes.SHOW_WIN_SHOWER:

            return {
                ...state, showWinShower: showWinShower
            };
        default:
            return state;
    }
}

export const actions = {
    winShowerStart: (startWinShower: boolean,winShowerAmount:number): any => ({
        type: actionTypes.START_WIN_SHOWER,
        startWinShower,winShowerAmount
    }),
    winShowerShow: (showWinShower: boolean): any => ({
        type: actionTypes.SHOW_WIN_SHOWER,
        showWinShower
    }),


};
